import React from 'react'
import { Typography } from '@mui/material'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import TextLabel from '../../../components/TextLabel/TextLabel'
import UserGuidance from '../../../components/UserGuidance/UserGuidance'
import TextFieldMui from 'src/components/TextFieldMui'
import theme from 'src/styles/theme'
import * as S from '../DivergenceProductPage.styles'

interface CountFormData {
  quantity: string
}

interface CountingStepProps {
  divergenceActiveAddress: string | undefined
  divergenceActiveProductDesc: string | undefined
  productResolutionData: any
  onCountSubmit: () => void
  registerCount: UseFormRegister<CountFormData>
  formatExpirationDate: (dateString: string) => string
  errors: FieldErrors<CountFormData>
}

const CountingStep: React.FC<CountingStepProps> = ({
  divergenceActiveAddress,
  divergenceActiveProductDesc,
  productResolutionData,
  onCountSubmit,
  registerCount,
  formatExpirationDate,
  errors,
}) => (
  <>
    <S.Info>
      <S.ContainerProductName>
        <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>Endereço</Typography>
        <UserGuidance>
          <TextLabel
            width='100%'
            height='3.2rem'
            backgroundColor={theme.colors.green4}
          >
            <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>
              {divergenceActiveAddress}
            </Typography>
          </TextLabel>
        </UserGuidance>
      </S.ContainerProductName>
      <S.ContainerProductName>
        <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>Produto</Typography>
        <UserGuidance>
          <TextLabel
            width='100%'
            height='3.2rem'
          >
            <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>
              {divergenceActiveProductDesc}
            </Typography>
          </TextLabel>
        </UserGuidance>
      </S.ContainerProductName>
    </S.Info>
    <S.CountingForm onSubmit={onCountSubmit}>
      <S.CountingContainer>
        <Typography style={{ fontWeight: 'bold', fontSize: '20px', textAlign: 'center' }}>
          Validade: {productResolutionData?.expirationDate ? formatExpirationDate(productResolutionData.expirationDate) : 'Não informada'}
        </Typography>

        <Typography style={{ fontSize: '22px', textAlign: 'center', marginBottom: '8px' }}>
          Digite a quantidade encontrada:
        </Typography>

        <TextFieldMui
          id='quantity'
          name='quantity'
          type='number'
          label='Quantidade'
          placeholder='Quantidade'
          autoComplete='off'
          size='small'
          margin='none'
          inputProps={{
            ...registerCount('quantity', { required: 'Campo obrigatório', min: { value: 0, message: 'O valor mínimo para a quantidade é 0' } }),
            'data-testid': 'input-quantity',
          }}
          error={!!errors.quantity}
          helperText={errors.quantity?.message}
          sx={{
            width: '100%',
            '& input': {
              padding: '12px',
              fontSize: '22px',
              textAlign: 'center',
            },
            '& .MuiOutlinedInput-root': {
              borderRadius: '4px',
            },
          }}
        />
      </S.CountingContainer>

      <S.ContainerButton>
        <S.CustomButton
          title='Contar'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          data-testid='button-count-test-id'
          disabled={!!errors.quantity}
          type='submit'
        />
      </S.ContainerButton>
    </S.CountingForm>
  </>
)

export default CountingStep
